// extracted by mini-css-extract-plugin
export default {"wrapper":"RuleBox_wrapper__pLZ-z","dashed-box":"RuleBox_dashed-box__XIiD0","dashedBox":"RuleBox_dashed-box__XIiD0"};